/**
 * Capitan embed-video.js v1.0.0
 *
 * Copyright brandung GmbH & Co.KG
 * http://www.brandung.de/
 *
 *
 * Date: 2018-09-06
 * MIT License (MIT)
 */
import Plyr from 'plyr';
var _ = {
  defaults: {
    componentSelector: '.embed-video',
    selectors: {
      wrapper: '.embed-video__wrapper',
      player: '.embed-video__player'
    },
    classes: {
      open: 'is-inactive'
    },
    modifier: {
      yt: 'embed-video--yt'
    },
    callbacks: {}
  }
};
var o = _.defaults;

function initEmbedVideo() {
  document.querySelectorAll(o.componentSelector).forEach(function (elem) {
    var localVideo = new Plyr(elem.querySelector(o.selectors.player));
    localVideo.once('canplay', function () {
      localVideo.currentTime = 0;
    });
  });
}
/**
 * initialize the componentasser
 * @export function
 */


export function init() {
  console.log('init embed-video');

  if (document.querySelector(o.componentSelector)) {
    import(
    /* webpackChunkName: "embed-video" */
    '!style-loader!css-loader!plyr/dist/plyr.css').then(function () {
      import(
      /* webpackChunkName: "polyfill" */
      'plyr/dist/plyr.polyfilled.min').then(function () {
        import(
        /* webpackChunkName: "embed-video" */
        'plyr/dist/plyr.min').then(function () {
          // Initialize the tab component.
          initEmbedVideo();
        });
      });
    });
  }
}